import { render, staticRenderFns } from "./NewMessageForm.vue?vue&type=template&id=512efe03&"
import script from "./NewMessageForm.vue?vue&type=script&lang=js&"
export * from "./NewMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./NewMessageForm.vue?vue&type=style&index=0&id=512efe03&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports